module.exports = __webpack_public_path__ + "static/img/help_02class_03.02b8dbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fdback/help_02class_03.png
// module id = 684
// module chunks = 140